var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignwhitedelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 6.8V18.7C15.3 19.1509 15.1209 19.5833 14.8021 19.9021C14.4833 20.2209 14.0509 20.4 13.6 20.4H3.4C2.94913 20.4 2.51673 20.2209 2.19792 19.9021C1.87911 19.5833 1.7 19.1509 1.7 18.7V6.8H15.3ZM11.05 0L12.75 1.7H17V5.1H0V1.7H4.25L5.95 0H11.05Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignwhitedelete);
export default __webpack_public_path__ + "static/media/assignwhitedelete.9c0294be666f0c755db0163a37239d2b.svg";
export { ForwardRef as ReactComponent };